import React, { useState } from 'react';
import { StreamlineIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { HoveredCopyButton } from '@rsos/components/capstone/HoveredButtons';
import { handleSetIsCopiedTimer } from '@rsos/components/capstone/HoveredButtons/helpers';
import { isEmpty } from '@rsos/utils/validators';
import { CopyableBox, IconWrapper } from './DataCardLocation.styles';

interface AltitudeInterface {
  altitude?: number | null;
  verticalUncertainty?: number | null;
}

const Altitude = ({ altitude, verticalUncertainty }: AltitudeInterface) => {
  const [isCopied, setIsCopied] = useState(false);
  const UNKNOWN = 'Unknown';

  const uncertaintyValue = !isEmpty(verticalUncertainty)
    ? `${verticalUncertainty?.toFixed(1)}m`
    : UNKNOWN;

  const altitudeValue = !isEmpty(altitude) ? altitude?.toFixed(1) : null;

  const copyableText = `Altitude: ${altitudeValue}m${
    uncertaintyValue !== UNKNOWN
      ? `, Vertical Uncertainty: ${uncertaintyValue}`
      : ''
  }`;

  if (!altitudeValue) {
    return null;
  }

  return (
    <CopyableBox isCopied={isCopied}>
      <IconWrapper mr={2}>
        <StreamlineIcon />
      </IconWrapper>
      <Box>
        <Box horizontal>
          <Text size="normal" color="secondaryText">
            Altitude:&nbsp;
          </Text>
          <Text size="normal" color="primaryText">
            {altitudeValue}m
          </Text>
        </Box>
        <Text size="small" color="secondaryText">
          Vertical Uncertainty: {uncertaintyValue}
        </Text>
      </Box>
      <HoveredCopyButton
        copyableText={copyableText}
        handleClick={() => handleSetIsCopiedTimer(setIsCopied)}
      />
    </CopyableBox>
  );
};

export default Altitude;
